//NBL1_Official Pages
import rules from "../../Data/Rules"
import settings from "../Settings/NBL1_Settings"
import Verification from "../Steps/Verification"
import Base_Details from "../Steps/BaseDetails"
import store from "../../veux/store"


let Conference
let NBL1Associations, ShirtSizes, OfficialAccredids
let step1, step2

// NBL1 Official Step Schema
const Load_NBL1_Official_Steps = () => {
    return {
        Portal: '2026 NBL1 Official',
        MainColor: "#f5924c",
        Logo: require(`../../assets/${Conference.logo}`),
        Title: `<h2>Mitsubishi ${Conference.Name} 2026 Officials Registration Form</h2>`,
        Description: `I HEREBY APPLY to be registered with ${Conference.Organisation} 
                            (${Conference.abbrev}) for the 2026 ${Conference.Name} season. I acknowledge 
                            that my information will be retained and used by ${Conference.abbrev} 
                            and the NBL to meet its obligations in administering the league and 
                            to ensure the registered person can be contacted when required for Tribunal or Integrity related matters.
                            <br><br>
                            All registered persons should note, in accordance with the Basketball Australia 
                            (BA) National Integrity Framework. BA may share personal information relating 
                            to Participants with Betting Operators, law enforcement agencies, government 
                            agencies or other sporting organisations to prevent and investigate match-fixing 
                            incidents.
                            <br>
                            <b>Please note all submitted registrations are PENDING APPROVAL subject to accreditation</b>`,
        userData: {},
        Model: {},
        steps: [
            // Step 1
            step1,
            // Step 2
            step2,
            // Step 3
            {
                stepno: 3,
                title: 'Rego',
                valid: true,
                information: '',
                Schema: {
                    Association: {
                        type: "select",
                        label: "Select Association",
                        outlined: true,
                        dense: true,
                        col: 12,
                        rules: [rules.requiredMsg('Association is Required')],
                        class: 'mx-1 px-1',
                        items: NBL1Associations,
                        returnObject: true,
                        itemText: 'Detail',
                        Role: null,
                        Accreditation: null,
                        AccredStart: '',
                        AccredEnd: '',
                        AccredTeam: Conference.Code_id,
                        Startslot: `If you work/cover for more than one association please select the one you cover the most`,
                        OUG: { Contact_Roles: true, Type: "Associations" }
                    },
                    Position: {
                        type: "select",
                        label: "Role",
                        outlined: true,
                        dense: true,
                        class: 'mx-1 px-1',
                        rules: [rules.requiredMsg('Role is Required')],
                        items: settings.OfficialRoles,
                        value: '',
                        onInput: async (ev) => {
                            let index = settings.OfficialRoles.findIndex((ele) => {
                                return (ele == ev.data.Position);
                            })
                            ev.schema.Association.Role = settings.OfficialRoleids[index]
                            ev.schema.Association.Accreditation = settings.LoadExtAccreds(Conference.Code_id).OfficialAccredids[index]
                            console.log(settings.LoadExtAccreds(Conference.Code_id).OfficialAccredids[index])
                            ev.schema.showUniformDetails.hidden = true
                            ev.schema.ShirtSize.hidden = true;
                            ev.schema.ShirtSize.rules = []

                            if (ev.data.Position == "Referee" || ev.data.Position == "Referee Coach") {
                                ev.schema.FrequentFlyer.hidden = false
                            } else {
                                ev.schema.FrequentFlyer.hidden = true;
                            }
                            if ((ev.data.Position == "Referee" || ev.data.Position == "Referee Coach") && Conference.Code_id == 3033) {
                                ev.schema.ShirtSize.hidden = false;
                                ev.schema.ShirtSize.rules = [rules.requiredMsg('Shirt Size is required')]
                            }
                            if (
                                (ev.data.Position == "Referee" || ev.data.Position == "Referee Coach" ||
                                    (ev.data.Position == "Statistician" || ev.data.Position == "ScoreBench"))
                                && Conference.Code_id == 3034) {
                                ev.schema.stateSupplier.hidden = false;
                                ev.schema.stateSupplier.rules = [rules.requiredMsg('A completed Statement of Supplier Form is Required')]
                            } else {
                                ev.schema.stateSupplier.hidden = true;
                                ev.schema.stateSupplier.rules = []
                            }
                            if (Conference.Code_id === 3031) {
                                ev.schema.RSLLogo.hidden = false
                                ev.schema.RSLVet.hidden = false
                                ev.schema.RSLVet.rules = [rules.requiredMsg('Served in the Australian Defence Forces is required')]
                                ev.schema.RSLVetOther.hidden = false
                                ev.schema.RSLVetOther.rules = [rules.requiredMsg('Family who Served in the Australian Defence Forces is required')]
                            } else {
                                ev.schema.RSLLogo.hidden = true
                                ev.schema.RSLVet.hidden = true
                                ev.schema.RSLVet.rules = []
                                ev.schema.RSLVetOther.hidden = true
                                ev.schema.RSLVetOther.rules = []
                            }
                        },
                        OUG: { Contact_Details: { Type: 346, Action: "Unique" } }
                    },
                    DOB: {
                        type: 'text',
                        ext: 'date',
                        locale: 'en',
                        label: `Date of Birth (${store.getters.getdateFormat})`,
                        outlined: true,
                        dense: true,
                        mask: store.getters.getdateMask,
                        rules: [rules.requiredMsg('Date of Birth is Required'),
                        rules.minAge(`The NBL1 has a minimum age in all divisions that an official
                                    must turn at least 14 years of age during
                                    the year in which the official seeks to register.
                                    You are not eligible to register for this current competition year`, '2012-01-01')],
                        class: 'mx-1 px-1',
                        // onInput: (ev, portal) => { },
                        OUG: { Contacts: { Field: "date_of_birth" } }
                    },
                    ShirtSize: {
                        type: "select",
                        label: "Select your Shirt Size",
                        outlined: true,
                        dense: true,
                        hidden: true,
                        rules: [rules.requiredMsg('Shirt Size is required')],
                        class: 'mx-1 px-1',
                        items: ShirtSizes,
                        returnObject: true,
                        itemText: 'Detail',
                        Endslot: `<h5 style="color:red;">Please Note: sizing listed will make allowance for Male or Female fittings as indicated by your gender.</h5>`,
                        OUG: { Contact_Details: { Type: 634, Action: "Unique" } }
                    },
                    showUniformDetails: {
                        type: 'img',
                        src: `${settings.LoadExtForm('Stats Uniform', Conference.Code_id)}`,
                        // height: "800px",
                        // width: "100%",
                        //maxHeight: 1366,
                        //maxWidth: 768
                        contain: true,
                        hidden: true,
                        class: "ma-2",
                        Startslot: `As part of your NBL1 South registration you will 
                                receive a t-shirt, please select your size from the drop down menu. 
                                We wish to present the league as professionally as we can and expect 
                                the t-shirt to be worn on game day. We will send you a link in the 
                                coming weeks should you wish to purchase any other apparel that can 
                                be worn game day.`,
                    },
                    FrequentFlyer: {
                        type: 'text',
                        label: 'Frequent Flyer Details',
                        outlined: true,
                        dense: true,
                        hidden: true,
                        class: 'mx-1 px-1',
                        OUG: { Contact_Details: { Type: 1048, Action: "Unique" } }
                    },
                    stateSupplier: {
                        type: 'file',
                        label: 'Statement of Supplier Form',
                        multiple: false,
                        outlined: true,
                        hidden: true,
                        dense: true,
                        accept: "image/*,application/pdf",
                        rules: [rules.fileSize()],
                        class: 'mx-1 px-1',
                        OUG: {
                            Contact_Details: {
                                Type: 1867,
                                Action: "SingleDesc",
                                Description: "Statement of Supplier Form",
                            }
                        },
                        Startslot: `<p style="text-align:center;color:lightgreen;font-size:12px;">Basketball Queensland Statement of Supplier Form – (Please upload a filled in copy of your form <a href="https://caat-p-001.sitecorecontenthub.cloud/api/public/content/0a46cffad58b4b4ab08df3c3db563e42_Statement_by_a_supplier.pdf" target="blank">Click Here to Download the Form</a>)</p>`
                    },
                    RSLLogo: {
                        type: 'img',
                        hidden: true,
                        src: `https://nbl1.basketball/Documents/RSL_Vic_Logo.png`,
                        width: "50%",
                        contain: true,
                        class: "ma-auto",
                    },
                    RSLVet: {
                        addText: " in the Australian Defence Forces",
                        type: "select",
                        label: "I have served in the Australian Defence Forces",
                        outlined: true,
                        dense: true,
                        hidden: true,
                        rules: [],
                        class: 'mx-1 px-1',
                        items: ["No - I have not Served", "Yes - I have Served", "Rather Not Say - if I Served"],
                        value: '',
                        col: 12,
                        Startslot: `<p style="text-align:center;color:lightgreen;font-size:12px;">
                                <b>As part of BV's partnership with RSL Victoria, please can you advise if you have served in the Australian Defence Forces including Reservists</b>
                                </p>`,
                        OUG: {
                            Contact_Details: {
                                Type: 3865,
                                Action: "SingleDesc",
                                Description: 'Served in the Australian Defence Forces',
                            }
                        }
                    },
                    RSLVetOther: {
                        addText: "  to family member served in the Australian Defence Forces",
                        type: "textarea",
                        label: "Family members who served",
                        outlined: true,
                        dense: true,
                        hidden: true,
                        rules: [],
                        class: 'mx-1 px-1',
                        items: ["No", "Rather Not Say", "Spouse", "Parent", "Grandparent", "Sibling", "Child", "Aunty", "Uncle", "Other"],
                        value: '',
                        col: 12,
                        Startslot: `<p style="text-align:center;color:lightgreen;font-size:12px;">
                            <b>Has a member of your family (spouse, parent, grandparent, sibling, child, aunty or uncle) ever served in the Australia Defence Forces including Reservists?
                        </p>`,
                        OUG: {
                            Contact_Details: {
                                Type: 3865,
                                Action: "SingleDesc",
                                Description: 'Family Served in the Australian Defence Forces',
                            }
                        }
                    },
                },
            },
            // Step 4
            {
                stepno: 4,
                title: 'Integrity',
                valid: true,
                information: `<div style="padding-bottom: 25px; line-height: 200%">
                                All Officials must complete or provide proof of completion for the following E-Learning sessions provided by Basketball Australia to complete your registration and compete in ${Conference.Name} <br>
                                <br>
                                <h4>Basketball Australia</h4>
                                1. <a href="https://basketballaustralia.etrainu.com/training/" target="_blank">BA Gambling and Match-Fixing Course</a>
                                - <b>COMPLETE ONCE (NEW OFFICIALS THAT HAVE NOT COMPLETED)</b>
                                <br>
                                2. <a href="https://bit.ly/BA-annual-update" target="_blank">BA NBL1 Integrity Annual Update (New 2026)</a>
                                <br>
                                3. <a href="https://bit.ly/BA-safeguarding" target="_blank">BA Child Safeguarding</a>
                                <br>
                                4. BA Face to Face Integrity Session - <b>COMPLETE ANNUALLY</b>
                                <br><br>
                                If you have already completed these courses and need to retrieve your proof of completion, please click the relevant link below:
                                <br>
                                <a href="https://basketballaustralia.etrainu.com/training/index.cfm?event=page.login" target="_blank">Retrieve BA Certifcates</a>
                    
                            </div>`,
                Schema: {
                    MatchFixing: {
                        type: 'file',
                        label: 'BA Integrity Gambling & Match Fixing Certificate',
                        multiple: false,
                        outlined: true,
                        hidden: store.getters.integrity,
                        dense: true,
                        accept: "image/*,application/pdf",
                        rules: (store.getters.integrity) ? [] : [rules.requiredMsg('Introduction to Match-Fixing Certificate is Required'), rules.fileSize()],
                        class: 'mx-1 px-1',
                        OUG: {
                            Contact_Details: {
                                Type: 1867,
                                Action: "SingleDesc",
                                Description: "BA Integrity Gambling & Match Fixing Certificate",
                            }
                        },
                        Startslot: `<p style="text-align:center;color:lightgreen;font-size:12px;">Basketball Australia Gambling and Match Fixing Course Certificate – (Please upload a screenshot of your Certificate <a href="https://nbl1.basketball/Other_Documents/GamblingMatchFixingExample.jpg" target="blank">Click Here for Example</a>)</p>`
                    },
                    haveMatchFixing: {
                        type: 'text',
                        dense: true,
                        disabled: true,
                        hidden: !store.getters.integrity,
                        class: 'mx-1 px-1',
                        Startslot: `<H4 style="text-align:center;color:red">We already have a copy of your BA Integrity Gambling & Match Fixing Certificate</H4>`
                    },
                    NBL1AnnualUpdate2026: {
                        type: 'file',
                        label: 'NBL1 Annual Update 2026',
                        multiple: false,
                        outlined: true,
                        dense: true,
                        accept: "image/*,application/pdf",
                        rules: [rules.requiredMsg('NBL1 Annual Update 2026 Certificate is Required'), rules.fileSize()],
                        class: 'mx-1 px-1',
                        OUG: {
                            Contact_Details: {
                                Type: 1867,
                                Action: "SingleDesc",
                                Description: "NBL1 Annual Update 2026 Certificate",
                            }
                        },
                        Startslot: `<p style="text-align:center;color:lightgreen;font-size:12px;">NBL1 Integrity Update – (Please upload your certificate here)`
                    },
                    ChildSafeGuarding: {
                        type: 'file',
                        label: 'BA Safeguarding Children in Basketball',
                        multiple: false,
                        outlined: true,
                        dense: true,
                        accept: "image/*,application/pdf",
                        rules: [rules.requiredMsg('BA Safeguarding Children in Basketball Certificate is Required'), rules.fileSize()],
                        class: 'mx-1 px-1',
                        OUG: {
                            Contact_Details: {
                                Type: 1867,
                                Action: "SingleDesc",
                                Description: "BA Safeguarding Children in Basketball Certificate",
                            }
                        },
                        Startslot: `<p style="text-align:center;color:lightgreen;font-size:12px;">BA Safeguarding Children in Basketball - Please upload your certificate here</p>`
                    },
                    BAIntegrity: {
                        type: 'checkbox',
                        label: `Please check this box if you agree to abide by Basketball Australia's National Integrity Framework`,
                        color: "primary",
                        value: "Agree to BA National Integrity Framework",
                        rules: [rules.requiredMsg('Confirmation of acceptance of BA Integrity Framework is Required')],
                        class: 'mx-1 px-1',
                        col: 12,
                        Startslot: `<h3>Integrity Requirements</h3>`,
                        Endslot: `<h4 class="slot">
                                        I agree to abide with the BA National Integrity Framework, BA may share personal information relating to Participants with Betting Operators, law enforcement agencies, government agencies or other sporting organisations to prevent and investigate match-fixing incidents.
                                        <br>
                                            <a href="https://australia.basketball/integrity/" target="_blank">Click here to review National Integrity Framework</a>
                                    </h4>`,
                        OUG: { Answer: true }
                    },
                },
                PreStep: (thisStep, portal) => {
                let { Model, Schema } = thisStep
                Schema.MatchFixing.hidden = store.getters.integrity
                Schema.MatchFixing.rules = (store.getters.integrity) ? [] : [rules.requiredMsg('Introduction to Match-Fixing Certificate is Required')]
                Schema.haveMatchFixing.hidden = !store.getters.integrity
                },
            },
            // Step 5
            {
                stepno: 5,
                title: 'Confirmation',
                valid: true,
                information: '',
                Schema: {
                    // COVID: {
                    //     type: 'checkbox',
                    //     label: `I have read and agree to abide to any ${Conference.Organisation} determinations on participation eligibility at any point relatable to COVID 19 or other.`,
                    //     color: "primary",
                    //     value: "Agree to abide by COVID requirements",
                    //     hidden: (Conference.Code_id === 3034),
                    //     rules: (Conference.Code_id === 3034) ? [] : [rules.requiredMsg('Confirmation of acceptance of COVID Requirements is Required')],
                    //     class: 'mx-1 px-1',
                    //     col: 12,
                    //     Startslot: `<h3>COVID Requirements</h3>`,
                    //     Endslot: `<a href=${settings.LoadExtForm('COVID', Conference.Code_id)} target="blank">
                    //                     ${Conference.Organisation} Vaccination Requirements</a>`,
                    //     OUG: { Answer: true }
                    // },
                    Participate: {
                        type: 'checkbox',
                        label: `I have read and agree to the terms and conditions of participation 
                            in NBL1. As laid out in the ${Conference.Name} Rules`,
                        color: "primary",
                        value: "Agree to all Terms and Conditions for NBL1",
                        rules: [rules.requiredMsg('Confirmation of acceptance of Terms and Conditions is Required')],
                        class: 'mx-1 px-1',
                        col: 12,
                        Startslot: `<h3>Participation Requirements</h3>`,
                        Endslot: `<a href=${settings.LoadExtForm('T&Cs', Conference.Code_id)} target="blank">
                                        ${Conference.Name} Rules</a>`,
                        OUG: { Answer: true }
                    },
                    cocConfirm: {
                        type: 'checkbox',
                        label: `I confirm that I will adhere to the ${Conference.Organisation} Code of Conduct`,
                        color: "primary",
                        value: "Confirm I will adhere to NBL1 Code of Conduct",
                        rules: [rules.requiredMsg('Confirmation of Code of Conduct is Required')],
                        class: 'mx-1 px-1',
                        col: 12,
                        Startslot: `<h3>Code of Conduct Requirements</h3>`,
                        Endslot: `<a href=${settings.LoadExtForm('COC', Conference.Code_id)} target="blank">
                                            ${Conference.Organisation} Code of Conduct</a>`,
                        OUG: { Answer: true }
                    },
                    useImages: {
                        type: 'checkbox',
                        label: `I acknowledge that ${Conference.abbrev},
                                        ${Conference.Name} and my Club may use images,
                                        video, or similar of me for the promotion of the League
                                        and the Club.`,
                        color: "primary",
                        value: "Acknowledge use of my Images and Video",
                        rules: [rules.requiredMsg('Use of Images confirmation is Required')],
                        class: 'mx-1 px-1',
                        col: 12,
                        Startslot: `<h3>Images Requirements</h3>`,
                        OUG: { Answer: true }
                    },
                    attendTribunal: {
                        type: 'checkbox',
                        label: `I undertake to attend meetings of the ${Conference.Organisation} Tribunal whenever required to do so and consent to the subsequent reporting of the proceedings of such meetings and hearings.`,
                        color: "primary",
                        value: "Agree to attend Tribunal or other meetings",
                        rules: [rules.requiredMsg('Agreement to Attend is Required')],
                        class: 'mx-1 px-1',
                        col: 12,
                        Startslot: `<h3>Tribunal Requirements</h3>`,
                        OUG: { Answer: true }
                    },
                    Concussion: {
                        type: 'checkbox',
                        label: `I confirm that I will adhere to the ${Conference.Organisation} Concussion Protocols`,
                        color: "primary",
                        value: "I Confirm I will adhere to NBL1 Concussion Protocols",
                        rules: (Conference.Code_id === 3033 || Conference.Code_id === 3032) ? [] : [rules.requiredMsg('Confirmation of NBL1 Concussion Protocols is Required')],
                        class: 'mx-1 px-1',
                        col: 12,
                        hidden: (Conference.Code_id === 3033 || Conference.Code_id === 3032),
                        Startslot: `<h3>Concussion Requirements</h3>`,
                        Endslot: `<a href=${settings.LoadExtForm('Concussion', Conference.Code_id)} target="blank">
                                            ${Conference.Organisation} Concussion Protocols</a>`,
                        OUG: { Answer: true }
                    },
                    infoAccurate: {
                        type: 'checkbox',
                        label: 'I confirm that I have provided infomation honestly and that it is both true and accurate.',
                        color: "primary",
                        value: "Confirm information all honest and correct",
                        rules: [rules.requiredMsg('Accurate Information confirmation is Required')],
                        class: 'mx-1 px-1',
                        col: 12,
                        Startslot: `<h3>Information Requirements</h3>`,
                        OUG: { Answer: true }
                    },
                },
            },
            // Step 6
            {
                stepno: 6,
                title: 'Finalisation',
                valid: true,
                information: `Thank you for your submitted registration for the 2026 NBL1 season.</br>
                            Please note this submitted registration is <b>PENDING APPROVAL</b> from the league and will be reviewed.<br></br>
                            You and your association delegate will receive an email notification once this has been approved by the league.<br></br>
                            <hr><br></br>
                            Please stay up to date with all NBL1 news and information throughout the season on the <a href="https://nbl1.com.au/" target="blank">NBL1 website</a><br></br>`,
                Model: {},
                Schema: {}
            }
        ]
    }
}

export default {

    LoadSchema: async (Parameters) => {
        Conference = settings.ConfDetails.find((ele) => {
            return Parameters.Conference == ele.Code_id;
        })
        step1 = await Verification.LoadSchema(1);
        step2 = await Base_Details.LoadSchema(2);
        ({ OfficialAccredids, NBL1Associations } = settings.LoadExtAccreds(Conference.Code_id))
        ShirtSizes = await settings.LookupShirtSizes()
        return Load_NBL1_Official_Steps()
    },

}